/**
 * useFlowOptimizerTrackers — the trackers whose Flow Optimizer + Scheduler
 * this deployment offers: the enabled trackers that have the `flowOptimizer`
 * capability, in registry order (Voluum, Binom, then any other).
 * For Media Devoted | Created By Ciro Autiero
 */

import { useMemo } from 'react';
import { trackerCan, type TrackerId } from '@trafficpulse/shared';

import { useEnabledTrackers } from '@/features/trackers/useEnabledTrackers';

export function flowOptimizerTrackers(enabled: readonly TrackerId[]): readonly TrackerId[] {
  return enabled.filter((id) => trackerCan(id, 'flowOptimizer'));
}

export function useFlowOptimizerTrackers(): readonly TrackerId[] {
  const enabled = useEnabledTrackers();
  return useMemo(() => flowOptimizerTrackers(enabled), [enabled]);
}
